import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-publish-video",
  "use": "icon-publish-video-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-publish-video\">\n  <rect x=\"2.5\" y=\"5\" width=\"14\" height=\"14\" rx=\"2\" ry=\"2\" />\n  <polygon points=\"21.5 7.5 16.5 11 16.5 13 21.5 16.5 21.5 7.5\" />\n  <polygon points=\"8 9.5 12 12 8 14.5 8 9.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol